import {atomWithStorage} from 'jotai/utils';

/** Per-user flag: welcome tooltip on the customize (gear) button was dismissed. */
export type DashboardCustomizeHintStore = Record<string, boolean>;

export const dashboardCustomizeHintDismissedAtom = atomWithStorage<DashboardCustomizeHintStore>(
  'dashboard:customizeHintDismissed',
  {},
  undefined,
  {getOnInit: true}
);
